import type { CSSProperties, FC } from 'react';
import { Progress } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

export interface CompactCircularProgressProps {
    percent: number;
    size?: number;
    strokeColor?: string;
    style?: CSSProperties;
}

/** Compact circular progress used in dense resource footers and collapsible summaries. */
const CompactCircularProgress: FC<CompactCircularProgressProps> = ({ percent, size = 16, strokeColor, style }) => {
    const { token } = useAntDesignTheme();

    return (
        <Progress
            percent={Math.min(100, Math.max(0, percent))}
            showInfo={false}
            strokeColor={strokeColor ?? token.blue5}
            strokeWidth={16}
            success={{ strokeColor: strokeColor ?? token.orange6 }}
            trailColor={token.colorBorder}
            type='circle'
            width={size}
            style={{ verticalAlign: '1px', ...style }}
        />
    );
};

export default CompactCircularProgress;
